export default __webpack_public_path__ + "static/media/product-image-5.b7812fd8.jpg";